import {CircularProgress} from "@mui/material";
import React from "react";

export function Loading() {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <CircularProgress size={100} color="primary"/>
        </div>
    )
}